import { CallApi, handleJSONResponse } from './common';
import { ImportLog } from '@services/import-catalog/types/import-log';

const callAPI = CallApi('import-catalog');

export const start = async (artistId: string) => {
  const response = await callAPI(`/import/${artistId}`, 'GET');

  return await handleJSONResponse(response);
};

export const progress = async (artistId: string): Promise<ImportLog> => {
  const response = await callAPI(`/status/${artistId}`, 'GET');

  return await handleJSONResponse(response);
};
